angular.module('v3sWbtPlayerApp').factory('v3sScormDataLmsAdapterService', ["v3sLog", function (v3sLog) {

    // SCORM Constants
    var VARS = {
        SCORM_TRUE: { value: 'true' },
        SCORM_FALSE: { value: 'false' },

        STATUS_COMPLETED: { value: 'cmi.core.lesson_status' },
        STATUS_PASSED: { value: '' },

        SCORE_RAW: { value: 'cmi.core.score.raw' },
        SCORE_MIN: { value: 'cmi.core.score.min' },
        SCORE_MAX: { value: 'cmi.core.score.max' },
        SCORE_SCALED: { value: '' },

        SUSPEND_DATA: { value: 'cmi.suspend_data' },
        GLOBAL_SUSPEND_DATA: { value: 'cmi.viwis.global.suspend_data' },

        SESSION_TIME: { value: 'cmi.core.session_time' },

        STUDENT_ID: { value: 'cmi.core.student_id' },
        STUDENT_NAME: { value: 'cmi.core.student_name' },

        NAV_MODE: { value: 'cmi.ins.navigation_mode' },
        VALID_REQUEST_CONTINUE: { value: 'cmi.ins.nav.request_valid.continue' },
        VALID_REQUEST_PREVIOUS: { value: 'cmi.ins.nav.request_valid.previous' },
        VALID_REQUEST_CHOICE: { value: 'cmi.ins.nav.request_valid.choice.{target=[PARAM]}' },

        NAV_REQUEST: { value: 'cmi.ins.nav.request' },
        NAV_REQUEST_CONTINUE: { value: 'continue' },
        NAV_REQUEST_PREVIOUS: { value: 'previous' },
        NAV_REQUEST_CHOICE: { value: '{target=[PARAM]}choice' },

        LOCATION: { value: 'cmi.core.lesson_location' }
    };

    //SCORM API
    var API = null;
    var initialized = false;

    function isError(number) {
        return number !== "0" && number !== 0;
    }

    function findAPI(win) {
        var findAPITries = 0;
        var findAPITriesMax = 5;
        while (!win.API && !!win.parent && win.parent !== win) {
            findAPITries++;

            if (findAPITries > findAPITriesMax) {
                break;
            } else {
                win = win.parent;
            }
        }

        var result = { adapter: null, findAPITries: findAPITries };
        if (!!win.API) {
            result.adapter = {
                type: typeof win.API,
                LMSInitialize: typeof win.API.LMSInitialize,
                LMSFinish: typeof win.API.LMSFinish,
                LMSGetValue: typeof win.API.LMSGetValue,
                LMSSetValue: typeof win.API.LMSSetValue,
                LMSCommit: typeof win.API.LMSCommit,
                LMSGetLastError: typeof win.API.LMSGetLastError,
                LMSGetErrorString: typeof win.API.LMSGetErrorString,
                LMSGetDiagnostic: typeof win.API.LMSGetDiagnostic
            };
        }
        v3sLog.debug("FindAPI", result);

        if (!!win.API) {
            return win.API;
        } else {
            return null;
        }
    }

    function getAPI() {
        var theAPI = null;

        v3sLog.debug("Search for Adapter in this window...");
        theAPI = findAPI(window);
        if (!theAPI && !!window.opener) {
            v3sLog.debug("Search for Adapter in opener...");
            theAPI = findAPI(window.opener);
        }

        return theAPI;
    }

    /*
     * Init connection with LMS
     */
    function initialize() {
        API = getAPI();
        v3sLog.debug("LMSInitialize");
        if (!API) {
            throw "No LMS adapter found.";
        }

        var result = API.LMSInitialize("");
        v3sLog.debug("LMSInitialize Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.LMSGetLastError();
            var errorDescription = "Error: " + API.LMSGetLastError() +
                " Description: " + API.LMSGetErrorString(errorNumber) +
                " Diagnostic: " + API.LMSGetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        } else {
            initialized = true;
        }
    }

    function finish(forced) {
        v3sLog.debug("LMSFinish");
        var result = API.LMSFinish("");
        v3sLog.debug("LMSFinish Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.LMSGetLastError();
            var errorDescription = "Error: " + API.LMSGetLastError() +
                    " Description: " + API.LMSGetErrorString(errorNumber) +
                    " Diagnostic: " + API.LMSGetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        }

        API = null;
        initialized = false;
    }

    function getValue(scormKey, param) {
        var result = "";

        if (!!scormKey && !!scormKey.value) {

            var key = scormKey.value;
            if (typeof param !== 'undefined') {
                key = key.replace("[PARAM]", param);
            }

            v3sLog.debug("LMSGetValue", key);
            result = API.LMSGetValue(key);
            v3sLog.debug("LMSGetValue Result", result);

            if (result === "") {
                var errorNumber = API.LMSGetLastError();
                if (isError(errorNumber)) {
                    var errorDescription = "Error: " + errorNumber +
                        " Description: " + API.LMSGetErrorString(errorNumber) +
                        " Diagnostic: " + API.LMSGetDiagnostic(errorNumber);
                    v3sLog.debug("LMS Error", errorDescription);
                    throw errorDescription;
                }
            }
        }
        return result;

    }

    function setValue(scormKey, scormValue, param) {
        if (!!scormKey && !!scormKey.value) {
            var key = scormKey.value;
            var value = scormValue;

            if (!!scormValue && !!scormValue.value) {
                value = scormValue.value;
            }
            if (typeof param !== 'undefined') {
                value = value.replace("[PARAM]", param);
                key = key.replace("[PARAM]", param);
            }

            v3sLog.debug("LMSSetValue", {key: key, value: value});
            var result = API.LMSSetValue(key, value);
            v3sLog.debug("LMSSetValue Result", result);

            if (result == VARS.SCORM_FALSE.value) {
                var errorNumber = API.LMSGetLastError();
                var errorDescription = "Error: " + API.LMSGetLastError() +
                        " Description: " + API.LMSGetErrorString(errorNumber) +
                        " Diagnostic: " + API.LMSGetDiagnostic(errorNumber);
                v3sLog.debug("LMS Error", errorDescription);
                throw errorDescription;
            }
        }
    }


    function commit() {
        v3sLog.debug("LMSCommit");
        var result = API.LMSCommit("");
        v3sLog.debug("LMSCommit Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.LMSGetLastError();
            var errorDescription = "Error: " + API.LMSGetLastError() +
                    " Description: " + API.LMSGetErrorString(errorNumber) +
                    " Diagnostic: " + API.LMSGetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        }
    }

    function isInitialized() {
        return !!API && initialized;
    }

    function getGlobalData() {
        var data = getValue(VARS.GLOBAL_SUSPEND_DATA);
        return data;
    }

    function setGlobalData(data) {
        setValue(VARS.GLOBAL_SUSPEND_DATA, data);
    }

    return {
        initialize: initialize,
        isInitialized: isInitialized,
        finish: finish,
        getValue: getValue,
        setValue: setValue,
        commit: commit,
        getGlobalData: getGlobalData,
        setGlobalData: setGlobalData,
        getAPI: getAPI,
        VARS: VARS
    };
}]);